import { Heading, Section } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { CommonFlexColumn } from 'components/layout/flex-column';
import { AccountWhole } from 'lib/interfaces/database/account';
import { useEffect } from 'react';
import useCustodiansStore from 'stores/custodians';
import useInvestorsStore from 'stores/investors';

export const AccountDetails = (props: { account: AccountWhole }) => {
  const { data: investors, load: loadInvestors } = useInvestorsStore();
  const { data: custodians, load: loadCustodians } = useCustodiansStore();

  useEffect(() => {
    loadInvestors();
    loadCustodians();
  }, []);

  return (
    <EB>
      <CommonFlexColumn>
        <Heading>
          {props.account.type} - {props.account.privateIdentifier}
        </Heading>

        <Section>What else do we want to show investors?</Section>
      </CommonFlexColumn>
    </EB>
  );
};
